// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609011808/js/" + chunkId + "." + {"44":"b33625d6","225":"02868bbf","481":"56e55e18","486":"90a62f9d","770":"725cfb12"}[chunkId] + ".0.807066261407166.chunk.js";
};